import script from "./Netflow.vue?vue&type=script&setup=true&lang=js"
export * from "./Netflow.vue?vue&type=script&setup=true&lang=js"

import "./Netflow.vue?vue&type=style&index=0&id=4e2ed969&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e2ed969"]])

export default __exports__